class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }
    if (this.mainDetailsToggle.open) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Привязываем обработчик клика по документу
    this.handleDocumentClick = this.onDocumentClick.bind(this);
    document.addEventListener('click', this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  onToggle() {
    super.onToggle(); // сохраняем анимации родителя

    if (this.mainDetailsToggle.open) {
      const allDetails = document.querySelectorAll('header-menu details');
      allDetails.forEach((detail) => {
        if (detail !== this.mainDetailsToggle && detail.open) {
          detail.removeAttribute('open');
          const summary = detail.querySelector('summary');
          if (summary) {
            summary.setAttribute('aria-expanded', false);
          }
        }
      });
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  // Обработчик клика по документу: если кликнули вне текущего header-menu, закрываем все пункты
  onDocumentClick(event) {


    // Используем composedPath(), чтобы учесть возможные перенесённые или клонированные узлы
    const path = event.composedPath();
    if (path.includes(this)) {
      // Клик был внутри текущего <header-menu>
      return;
    }

    // Закрываем все открытые <details> в этом конкретном <header-menu>
    const allDetails = this.querySelectorAll('details[open]');
    allDetails.forEach((detail) => {
      detail.removeAttribute('open');
      const summary = detail.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', false);
      }
    });
  }
}

customElements.define('header-menu', HeaderMenu);


